import React from "react";
import classes from "./CareersForm.module.css";

//Components
import Button from "../../../UI/Button/Button";

//This Component is a form displayed in a modal that collects input information and CV.
const CareersForm = (props) => {
  return (
    <div className={classes.container}>
      <div className={classes.item}>
        <h2>Send us Your CV:</h2>
      </div>
      <div className={classes.item}></div>
      <div className={classes.item}>
        <div className={classes.label}>First Name:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Last Name:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Address:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>City:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Email Address:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Phone Number:</div>
        <input className={classes.textField} />
      </div>
      <div className={classes.item}>
        <div className={classes.label}>Attach CV:</div>
        <input type="file" name="cv" className={classes.attach} />
      </div>
      <div className={classes.rowCenter}>
        <Button width={150} height={50}>
          Submit
        </Button>
      </div>
    </div>
  );
};
export default CareersForm;
